import { useMutation, UseMutationResult } from 'react-query';
import { ErrorWithData } from 'task-manager/bench-services-api/ErrorWithData';
import { BusinessService, CreateBusinessServiceInput } from '../types';

async function create(apiUrl: string, input: CreateBusinessServiceInput): Promise<BusinessService> {
  if (!apiUrl) throw new Error('Required properties are not set');

  const response: Response = await fetch(`${apiUrl}/business-service`, {
    method: 'POST',
    body: JSON.stringify(input),
    credentials: 'include',
  });

  if (!response.ok) {
    const error = (await response.json()) as Record<string, unknown>;
    throw new ErrorWithData('Failed to create business service', error);
  }
  return (await response.json()) as BusinessService;
}

interface UseCreateBusinessServiceProps {
  handleError: (error: Error) => void;
}

export const useCreateBusinessService = ({
  handleError,
}: UseCreateBusinessServiceProps): UseMutationResult<
  BusinessService,
  Error,
  CreateBusinessServiceInput
> => {
  const apiUrl = window.BENCH?.auApi?.SETUP_BUSINESS_SERVICE_API_URL || '';

  return useMutation({
    mutationFn: input => create(apiUrl, input),
    onError: handleError,
  });
};
